import React from "react";
import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer,
} from "@shopify/polaris";

export default function SeoTemplateSkeleton(props) {
  return (
    <Card>
      <Card.Section>
        <TextContainer>
          <SkeletonDisplayText />
          <SkeletonBodyText />
          <SkeletonDisplayText />
          <SkeletonBodyText lines={4} />
        </TextContainer>
      </Card.Section>
      <Card.Section>
        <TextContainer>
          <SkeletonDisplayText />
          <SkeletonBodyText />
          <SkeletonDisplayText />
          <SkeletonBodyText lines={4} />
        </TextContainer>
      </Card.Section>
    </Card>
  );
}
